import React, { useEffect, useCallback } from "react";
import { FieldArray, useField, useFormikContext } from "formik";
import { connect } from "react-redux";

import {
	ExpertiseRepeaterStyled,
	ExpertiseRepeaterRow,
	RemoveButton,
} from "./styled";
import { Select } from "../Select";
import { MultiSelect } from "../MultiSelect";
import { RepeaterButton } from "../../RepeaterButton";
import {
	getExpertiseDisciplines,
	getDisciplinesByProfileType,
} from "../../../actions/companyActions";

export const ExpertiseRepeaterConnected = ({
	className,
	name,
	options,
	profileType,
	getDisciplinesByProfileType,
	getExpertiseDisciplines,
	required,
	testId,
	discription,
	...props
}) => {
	const { setFieldValue, values, errors, touched } = useFormikContext();
	const fieldValues = values[name] || [];

	// eslint-disable-next-line no-unused-vars
	const [field, meta] = useField(name);

	// Function to check for errors at a specific index
	const getFieldError = (index, fieldName) => {
		const indexErrors = errors[name] && errors[name][index];
		const indexTouched = touched[name] && touched[name][index];

		if (indexErrors && indexTouched && indexErrors[fieldName]) {
			return indexErrors[fieldName];
		}
		return null;
	};

	// Handler for expertise selection change
	const handleExpertiseChange = useCallback(
		(option, field, disciplineField) => {
			setFieldValue(disciplineField, []);
			setFieldValue(field.name, option.value);
		},
		[setFieldValue]
	);

	// Handler for adding a new row
	const handleAddRow = useCallback((arrayHelpers) => {
		arrayHelpers.push({ expertise: "", disciplines: [] });
	}, []);

	// Handler for removing a row
	const handleRemoveRow = useCallback((arrayHelpers, index) => {
		arrayHelpers.remove(index);
	}, []);

	useEffect(() => {
		if (profileType) {
			const profileTypeId =
				typeof profileType === "object" ? profileType.id : profileType;
			getDisciplinesByProfileType(profileTypeId);
		}
	}, [getExpertiseDisciplines, getDisciplinesByProfileType, profileType]);

	if (!options) {
		return <h4>Loading disciplines..</h4>;
	}

	return (
		<ExpertiseRepeaterStyled className={className}>
			<FieldArray
				name={name}
				render={(arrayHelpers) => (
					<div>
						{fieldValues &&
							fieldValues.length > 0 &&
							fieldValues.map((disciplineItem, index) => {
								// Get any errors for this row
								const expertiseError = getFieldError(index, "expertise");
								const disciplinesError = getFieldError(index, "disciplines");

								// Only show discipline error if expertise is selected
								const shouldShowDisciplineError =
									disciplinesError && disciplineItem.expertise;

								return (
									<div key={index}>
										{index !== 0 && (
											<RemoveButton
												type="button"
												remove
												onClick={() => handleRemoveRow(arrayHelpers, index)}
												data-testid={`${testId}-remove-button`}
											>
												Remove Row
											</RemoveButton>
										)}

										<div>
											{discription && index === 0 ? (
												<p className="mb-1 max-w-[50%] text-sm text-text-secondary-700">
													{discription}
												</p>
											) : null}
											<ExpertiseRepeaterRow className="!grid grid-cols-2 gap-6">
												<Select
													label={profileType === 3 ? "Service" : "Expertise"}
													name={`${name}.${index}.expertise`}
													className="col-span-1"
													options={Object.keys(options)}
													onChange={(option, field) =>
														handleExpertiseChange(
															option,
															field,
															`${name}.${index}.disciplines`
														)
													}
													freeText
													testId={`${testId}-single`}
													required={required}
													error={expertiseError}
												/>

												<MultiSelect
													label={profileType === 3 ? "Category" : "Discipline"}
													name={`${name}.${index}.disciplines`}
													className="col-span-1"
													options={options[disciplineItem.expertise]}
													defaultValue={disciplineItem.disciplines}
													required={required}
													testId={`${testId}-multi`}
													errorLeftAlign
													error={
														shouldShowDisciplineError ? disciplinesError : null
													}
												/>
											</ExpertiseRepeaterRow>
										</div>
									</div>
								);
							})}

						<RepeaterButton
							$small={true}
							text="Add Expertise Row"
							testId={`${testId}-add-row-button`}
							handleAddClick={() => handleAddRow(arrayHelpers)}
						/>
					</div>
				)}
			/>
		</ExpertiseRepeaterStyled>
	);
};

ExpertiseRepeaterConnected.defaultProps = {
	required: false,
};

const mapStateToProps = (state) => {
	return {
		options: state.companyProfile.expertiseDisciplinesByProfile,
	};
};

export const ExpertiseRepeater = connect(mapStateToProps, {
	getDisciplinesByProfileType,
	getExpertiseDisciplines,
})(ExpertiseRepeaterConnected);
